import { Toro } from '../../common/enumerations';
import { ControllerFwUpdateInfo } from './controller-fw-update-info.model';
import { DependentDeviceFwUpdateInfo } from './dependent-device-fw-update-info.model';
import { DeviceFwUpdateInfoListItem } from './device-fw-update-info-list-item.model';
import { DeviceFwUpdateInfo } from './device-fw-update-info.model';
import { LpcuFwUpdateInfo } from './lpcu-fw-update-info.model';

export class GatewayFwUpdateInfo extends DeviceFwUpdateInfo
{
    constructor(json: any = null)
    {
        super(json);

        if (json)
        {
            this.LocationName = json.LocationName;
            this.DependentDevices = json.DependentDevices.map(dd =>
            {
                if (dd.DeviceTypeId === Toro.DeviceType.LPCU || dd.DeviceTypeId === Toro.DeviceType.LPRO)
                {
                    return new LpcuFwUpdateInfo(dd);
                }
                else
                {
                    return new ControllerFwUpdateInfo(dd);
                }
            });

            this.DeviceUpdateList = json.DeviceUpdateList.map(item => new DeviceFwUpdateInfoListItem(item));
        }
    }

    DependentDevices: DependentDeviceFwUpdateInfo[] = [];
    DeviceUpdateList: DeviceFwUpdateInfoListItem[] = [];
    LocationName: string;

}
